export default function Cursor() {
  return null;
}
